import { Text } from '@chakra-ui/react';

import { useCampaigns, usePaginateCampaigns } from 'hooks/campaigns';
import { useFilters } from 'hooks/filters';

import AsyncTable from 'components/Tables/AsyncTable';
import StatusIndicator from 'components/StatusIndicator';
import dateFormat from 'functions/dateFormat';
import { useEffect } from 'react';

const columns = [
	{
		Header: 'Nome',
		accessor: 'name'
	},
	{
		Header: 'Status',
		accessor: 'is_active',
		Cell: ({ value }) => <StatusIndicator isActive={value} size="sm" />
	},
	{
		Header: 'Regional',
		accessor: 'regional.name'
	},
	{
		Header: 'Unidade',
		accessor: 'unit.name'
	},
	{
		Header: 'Formulário',
		accessor: 'form_config.name'
	},
	{
		Header: 'Data de criação',
		accessor: 'created_at',
		Cell: ({ value }) => <Text>{dateFormat(value)}</Text>
	}
];

const CampaignsTable = () => {
	const { filters } = useFilters();
	const { rows, page, perPage, total, setToDelete, setDeleteModalOpen } =
		useCampaigns();
	const [paginateCampaigns, { loading }] = usePaginateCampaigns();

	const deleteCampaign = (id) => {
		setToDelete(id);
		setDeleteModalOpen(true);
	};

	const fetchData = ({ pageSize, pageIndex }) => {
		if (pageSize != perPage) pageIndex = 1;
		paginateCampaigns({
			variables: {
				first: pageSize || perPage,
				page: pageIndex || page,
				...filters
			}
		});
	};

	useEffect(() => {
		if (filters && Object.keys(filters).length > 0) {
			paginateCampaigns({
				variables: {
					first: perPage,
					page,
					...filters
				}
			});
		}
	}, [filters]);

	return (
		<AsyncTable
			fetchData={fetchData}
			isLoaded={!loading}
			data={!loading ? rows : [{}, {}, {}, {}]}
			columns={columns}
			total={total}
			size={perPage}
			asyncPage={page}
			searchByName
			baseRoute="campanhas"
			removeAction={deleteCampaign}
			linkRow
		/>
	);
};

export default CampaignsTable;
